import { InjectionToken } from '@angular/core';
import { IBixiTableConfig } from './table.type';

export const BIXI_TABLE_CONFIG = new InjectionToken<IBixiTableConfig>('bixi-table-config');
